module.exports = __webpack_public_path__ + "static/media/interior1.08d83fd0.jpeg";